import * as R from 'ramda';
export function getLastBreadcrumbUrl(breadcrumbs) {
    return R.pipe(R.last, R.prop('to'))(breadcrumbs);
}
